module.exports = __webpack_public_path__ + "img/4f_r_gindako.704a42d9.jpg";